import { createContext } from 'react'

const defaultValue = {
    location: '',
    locationPickingInProgress: false,
}

const Context = createContext(defaultValue);

export default Context